export enum ScreenSize {
    x_small = 'xs',
    small = 'sm',
    medium = 'md',
    large = 'lg',
    x_large = 'xl'
}
